/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

// reducers
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';

// components
import { ItemsTable } from "./items-table";
import { CustomersFilterBarTimed } from "shared/components/bulma/customers-filter-bar";
import { ProductsFilterBarTimed } from "shared/components/bulma/products-filter-bar";

import * as helper from "./helper";

const DEFAULT_TABS = ['Missing', 'Kept'];
const QUERY_LIMIT_CHARS = 2;

const MissingItems = ({ location }) => {
    const [missingItems, setMissingItems] = useState([]);
    const [keptItems, setKeptItems] = useState([]);
    const [results, setResults] = useState([]);
    const [dirty, setDirty] = useState(false);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(DEFAULT_TABS[0]);

    const country = useSelector(selectCountry);
    const history = useHistory();

    const handleTabChange = (tab) => {
        setDirty(false);
        setLoading(true);
        setActiveTab(tab);
        const pathname = location.pathname;
        history.push({
            pathname,
            search: `?tab=${tab.toLowerCase()}`
        });
        setLoading(false);
    };

    const displayedData = activeTab === 'Missing' ? missingItems : keptItems;

    const handleFilterChange = ({ event, type }) => {
        if (!event?.target) {
            return;
        };

        const { value } = event.target;
        const { select, input } = value;

        const query = input.trim();
        if (select && query && query.length >= QUERY_LIMIT_CHARS) {
            (type === 'customers') ? searchCustomers({ field: select, query }) : searchProducts({ field: select, query });
        } else if (query === '') {
            setDirty(false);
            setResults([]);
        };
    };

    const searchCustomers = async ({ field, query }) => {
        setLoading(true);
        setDirty(true);
        const results = await helper.getItemsByUsers(activeTab, field, query, country);
        setResults(results);
        setLoading(false);
    };
    const searchProducts = async ({ field, query }) => {
        setLoading(true);
        setDirty(true);
        const results = await helper.getItemsByProducts(activeTab, field, query, country);
        setResults(results);
        setLoading(false);
    };

    useEffect(() => {
        const tab = new URLSearchParams(location.search).get('tab');
        if (tab) {
            const activeTab = DEFAULT_TABS.find((t) => t.toLowerCase() === tab.toLowerCase());
            setActiveTab(activeTab);
        };

        const getData = async () => {
            const missingItems = await helper.getMissingData('missing', country);
            setMissingItems(missingItems);
            const keptItems = await helper.getMissingData('kept', country);
            setKeptItems(keptItems);
            setLoading(false);
        };
        if (keptItems.length === 0) {
            getData();
        };
    }, [missingItems, keptItems, country, location.search]);

    return (
        <div className="container">
            <nav className="level">
                <div className="level-item">
                    <div>
                        <h1 className="title">Missing Items</h1>
                        <h2 className="heading is-2">Customers kept these products without informing us.</h2>
                    </div>
                </div>
                <div className="level-item has-text-centered">
                    <div className="level-right">
                        <div className="tabs is-large">
                            <ul>
                                {(DEFAULT_TABS.map((tab) => (
                                    <li key={tab} className={tab === activeTab ? 'is-active' : ''}>
                                        <a onClick={() => handleTabChange(tab)}>{tab}</a>
                                    </li>
                                )))}
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
            <div className="columns">
                <div className="column is-4">
                    <CustomersFilterBarTimed timer="500" onChange={(event) => handleFilterChange({ event, type: 'customers' })} />
                </div>
                <div className="column is-4"></div>
                <div className="column is-4">
                    <ProductsFilterBarTimed timer="500" onChange={(event) => handleFilterChange({ event, type: 'products' })} />
                </div>
            </div>
            {loading && (
                <progress className="progress is-large is-primary" max="100">15%</progress>
            )}
            {!loading && (
                <ItemsTable data={dirty ? results : displayedData} />
            )}
        </div>
    );
}

export { MissingItems };
